"use strict";

class PaymentsImportController {

    constructor($timeout,
                $window,
                Upload,
                SSHttpService,
                SSConfigService,
                SSAlertService,
                SSUtilService,
                OTPService,
                SSAppService,
                SSAwsService,
                SSUserService,
                SSConfirmationService
    ) {
        const self = this;

        self.$timeout = $timeout;
        self.$window = $window;
        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT;
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

        self.has_access = false;
        self.hideImportSection = false;
        if (self.SSUserService.isDeveloper() && self.SSUserService.hasPermission('DMS_SALES_PAYMENTS_IMPORT')) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.importParams = {};
        // Opt-in flag (WEB-3657): when ON, instrument rows that share the same
        // instrument number but differ in paid/interest amount are kept as
        // separate instruments instead of being merged. Off (0) by default so
        // the existing import behaviour is unchanged.
        self.importParams.allowDuplicateAmounts = 0;
        self.salesDataFileProcessed = false;
        self.exportType = 'full_sale_data';
        self.getDeveloperProperties();
    }

    getDeveloperProperties() {
        const self = this;

        self.properties = [];

        let url = 'sec/developer/properties/list';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let _properties = response.data.properties;

            jQuery.each(_properties, function (index, property) {
                if (property.status === self.PROPERTY_STATUS_APPROVED
                    || property.status === self.PROPERTY_STATUS_LISTED
                ) {
                    self.properties.push(property);
                }
            });

            self.$timeout(function () {
                jQuery("#property-select").niceSelect('update');
            });
        });
    }

    validateImportParams() {
        const self = this;

        if (!self.property_id) {
            return;
        }
        if (!self.importParams.paymentsExcelFile) {
            return;
        }

        return true;
    }

    importPayments() {
        const self = this;

        if (!self.importParams.paymentsExcelFile) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadPaymentsExcel(self.importParams.paymentsExcelFile);
            }
        );
    }


    uploadPaymentsExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        if(self.exportType === 'full_sale_data'){
            self.Upload.upload({
                url: self.SSHttpService.getApiURL('sec/developer/import/payments-wing-tai/parse'),
                method: 'POST',
                data: {
                    property_id: self.property_id,
                    import_file: file
                },
                withCredentials: true
            }).then(
                function (response) {
                    loading(false);
                    self.progressUploadingFiles = false;

                    response = response.data ? response.data : {};

                    if (response.code !== 200) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    if (!response.data.payments) {
                        self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                        return;
                    }

                    self.importData = response.data;
                    self.hideImportSection = true;

                }, function (response) {

                    self.progressUploadingFiles = false;
                    self.SSAlertService.parseAndDisplayError(response);

                }, function (evt) {
                }
            );
        }else{
            const self = this;

            self.progressUploadingFiles = true;
            self.filesUploadProgress = 0;

            loading(true);
            self.Upload.upload({
                url: self.SSHttpService.getApiURL('sec/developer/import/sales-payments-instruments/parse'),
                method: 'POST',
                data: {
                    import_file: file
                },
                withCredentials: true
            }).then(function (response) {
                loading(false);
                self.progressUploadingFiles = false;

                response = response.data ? response.data : {};

                if (response.code !== 200) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                if (!response.data.sales_payments_instruments) {
                    self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                    return;
                }

                self.importData = response.data;

                if (self.importParams.paymentInstrumentsAssetsFiles && self.importParams.paymentInstrumentsAssetsFiles.length) {
                    self.uploadPaymentInstrumentAssetsFiles(self.importParams.paymentInstrumentsAssetsFiles);
                } else {
                    self._importPaymentInstrumentAssetsFiles();
                }

            }, function (response) {

                self.progressUploadingFiles = false;
                self.SSAlertService.parseAndDisplayError(response);

            }, function (evt) {
            });
        }

    }

    _importPayments() {
        const self = this;

        let importUrl = 'sec/developer/import/payments-wing-tai';

        // PARSE THROUGH ALL PAYMENTS AND REMOVE DATA WHICH HAS ERROR TRUE IN IT
        let payments = [];
        for (let i = 0; i < self.importData.payments.length; i++) {
            let payment = self.importData.payments[i];
            let hasError = false;
            for (let key in payment) {
                if (payment[key].error) {
                    hasError = true;
                    break;
                }
            }
            if (!hasError) {
                // payments.push(payment);
                // INSTEAD OF PUSHING PAYMENT OBJECT, PUSH PAYMENT OBJECT WITH VALUE FIELD
                let paymentObj = {};
                for (let key in payment) {
                    paymentObj[key] = payment[key].value;
                }
                payments.push(paymentObj);
            }
        }

        let params = {
            property_id: self.property_id,
            payments: payments,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Data is imported successfully.');
            self.progressUploadingFiles = false;
            self.$window.location.reload();
        });
    }

    goBack(){
        const self = this;

        self.$window.location.href = '/developer/sales/payments';
    }


    uploadPaymentInstrumentAssetsFiles(files) {
        const self = this;

        if (!files) return;
        let policyUrl = "";
        if(self.exportType === 'full_sale_data'){
            policyUrl = 'sec/developer/import/properties/s3-policy-document';
        }else{
            policyUrl = 'sec/developer/sales/documents/s3-policy-document?type=instruments';
        }
        let processedFiles = 0;

        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                    self.assets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importPaymentInstrumentAssetsFiles();
                    }
                });
            });
        });
    }

    _importPaymentInstrumentAssetsFiles() {
        const self = this;

        let importUrl = 'sec/developer/import/sales-payments-instruments';

        let params = {
            property_id: self.property_id,
            sales_payments_instruments: self.importData.sales_payments_instruments,
            assets: self.assets,
            // WEB-3657: keep same-instrument-no rows with different paid/interest
            // amounts as separate instruments when the operator opts in.
            allow_duplicate_amounts: self.importParams.allowDuplicateAmounts ? 1 : 0
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;
            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }
            // WEB-4314: drive the outcome message off the structured `summary`
            // block (WEB-3658) instead of announcing success unconditionally.
            let data = response.data ? response.data : {};
            let summary = data.summary;

            if (summary) {
                let failedCount = Array.isArray(summary.errors) ? summary.errors.length : 0;
                let skippedCount = summary.skipped_no_payment ? summary.skipped_no_payment : 0;

                if (failedCount === 0 && skippedCount === 0) {
                    self.SSAlertService.success('Success!', 'All data is imported successfully.');
                    self._clearImportFileInputs();
                    return;
                }

                // Partial / total failure: keep the file selection so the operator
                // can correct the workbook and re-import without re-picking it.
                self.SSAlertService.warning(
                    'Import completed with issues!',
                    self._formatImportSummaryWarning(summary)
                );
                return;
            }

            // Fallback for responses without a `summary` (pre-WEB-3658 API): the
            // legacy `errors` map is populated only by the thrown-exception path.
            let legacyErrors = self._formatLegacyImportErrors(data.errors);

            if (legacyErrors.length > 0) {
                self.SSAlertService.warning('Import completed with issues!', legacyErrors);
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');
            self._clearImportFileInputs();
        });
    }

    /**
     * Translate a machine reason code from `summary.errors[].reason` into text
     * an operator can act on.
     *
     * @remarks
     * WEB-4314: the API (DeveloperSalesImportController::importSalesPaymentsInstrumentsData)
     * emits snake_case codes for the rows it rejects itself, and the raw
     * exception message for rows that threw. Unknown values are passed through
     * verbatim so a new server-side code is still readable rather than blank.
     *
     * WEB-4320: WEB-4313 started qualifying a code with the detail found for
     * that row, as `<code>: <detail>` (e.g. `missing_required_columns:
     * otp_number, payment_type`). An exact-match lookup no longer resolves
     * that, so the operator saw the raw snake_case string; the code is now read
     * from before the first colon and the detail re-attached to the sentence.
     * A raw exception message that happens to contain a colon still falls
     * through verbatim, because the text before it is not a known code.
     *
     * @param {string} reason - Reason code, `code: detail`, or raw exception message.
     * @returns {string} Operator-facing description of the failure.
     */
    _describeImportReason(reason) {
        const self = this;

        // WEB-4320: `unit_number` is reference-only (the sale is resolved from
        // the OTP number), and a refund row satisfies the clause requirement
        // with `refund_clause_code`, so the old "all required" list named
        // columns the operator does not have to fill in.
        const REASONS = {
            'missing_required_columns': 'Missing required columns (OTP Number and Payment Type are required, plus either Payment Clause Code or Refund Clause Code)',
            'missing_payment_type_or_otp': 'Missing payment type or OTP number',
            'sale_not_found': 'No matching sale found for this OTP number',
            'payment_not_found': 'No matching payment found for this payment clause',
            'posting_period_closed': 'The posting period for this payment is closed',
            'unprocessed': 'Row was not processed'
        };

        if (!reason) {
            return 'Unknown error';
        }

        let separatorAt = String(reason).indexOf(':');
        let code = separatorAt === -1 ? String(reason) : String(reason).substring(0, separatorAt).trim();
        let detail = separatorAt === -1 ? '' : String(reason).substring(separatorAt + 1).trim();

        if (!REASONS[code]) {
            return reason;
        }

        if (!detail) {
            return REASONS[code];
        }

        if (code === 'missing_required_columns') {
            return REASONS[code] + ' - missing: ' + self._describeImportColumns(detail);
        }

        return REASONS[code] + ' (' + detail + ')';
    }

    /**
     * Render the server's list of column names as the sheet's own headings.
     *
     * @remarks
     * WEB-4320: `summary.errors[].reason` names missing columns by their
     * snake_cased sheet key (`otp_number`), and a requirement satisfied by
     * either of two columns is sent as a `a/b` pair
     * (`payment_clause_code/refund_clause_code`). Both are turned back into the
     * headings printed in the workbook so a finance-facing screen never shows a
     * raw key. A column the front end does not know is title-cased rather than
     * passed through, so a new server-side column stays readable.
     *
     * @param {string} columnList - Comma-separated column names from the API.
     * @returns {string} Comma-separated sheet headings.
     */
    _describeImportColumns(columnList) {
        const COLUMN_LABELS = {
            'otp_number': 'OTP Number',
            'payment_type': 'Payment Type',
            'payment_clause_code': 'Payment Clause Code',
            'refund_clause_code': 'Refund Clause Code',
            'unit_number': 'Unit Number',
            'block': 'Block',
            'otp_date': 'OTP Date',
            'sale_price_s': 'Sale Price'
        };

        let toLabel = function (name) {
            if (COLUMN_LABELS[name]) {
                return COLUMN_LABELS[name];
            }

            return name.split('_').map(function (word) {
                return word ? word.charAt(0).toUpperCase() + word.substring(1) : word;
            }).join(' ');
        };

        let labels = [];

        jQuery.each(String(columnList).split(','), function (i, column) {
            let name = column.trim();

            if (!name) {
                return;
            }

            // "a/b" means either column satisfies the requirement.
            labels.push(name.split('/').map(toLabel).join(' or '));
        });

        return labels.join(', ');
    }

    /**
     * Build the warning body for an import that did not complete cleanly.
     *
     * @remarks
     * WEB-4314: reports rows written vs. total, the rows skipped because no
     * matching payment was found, the failed count, and the first
     * MAX_LISTED_ERRORS `row / otp_no / reason` entries. Rendered inside an
     * element with `white-space: pre-line`, so newlines become line breaks.
     *
     * @param {Object} summary - The API's `data.summary` block: total, created,
     *                           updated, merged, skipped_no_payment, errors[].
     * @returns {string} Multi-line warning message.
     */
    _formatImportSummaryWarning(summary) {
        const self = this;

        const MAX_LISTED_ERRORS = 10;

        let total = summary.total ? summary.total : 0;
        let created = summary.created ? summary.created : 0;
        let updated = summary.updated ? summary.updated : 0;
        let merged = summary.merged ? summary.merged : 0;
        let skipped = summary.skipped_no_payment ? summary.skipped_no_payment : 0;
        let rowErrors = Array.isArray(summary.errors) ? summary.errors : [];

        let imported = created + updated + merged;

        let lines = [];

        lines.push(imported + ' of ' + total + ' row(s) imported'
            + ' (' + created + ' created, ' + updated + ' updated, ' + merged + ' merged).');

        if (skipped > 0) {
            lines.push(skipped + ' row(s) skipped - no matching payment found.');
        }

        if (rowErrors.length > 0) {
            lines.push(rowErrors.length + ' row(s) failed:');
        }

        jQuery.each(rowErrors.slice(0, MAX_LISTED_ERRORS), function (i, rowError) {
            let label = 'Row ' + (rowError.row ? rowError.row : (i + 1));

            if (rowError.otp_no) {
                label += ' (OTP ' + rowError.otp_no + ')';
            }

            lines.push(label + ': ' + self._describeImportReason(rowError.reason));
        });

        if (rowErrors.length > MAX_LISTED_ERRORS) {
            lines.push('...and ' + (rowErrors.length - MAX_LISTED_ERRORS) + ' more failed row(s).');
        }

        lines.push('Please correct the file and import the affected rows again.');

        return lines.join("\n");
    }

    /**
     * Flatten the legacy `data.errors` map into displayable lines.
     *
     * @remarks
     * WEB-4314: the map is keyed by unit number and each value is an *array* of
     * exception messages, so the previous string concatenation rendered
     * "[object Object]"-style output. Only reached when the API response
     * carries no `summary` block.
     *
     * @param {Object} errors - Legacy errors map: unit no. -> message[].
     * @returns {string} Multi-line message, empty when there is nothing to show.
     */
    _formatLegacyImportErrors(errors) {
        let lines = [];

        if (!errors) {
            return '';
        }

        jQuery.each(errors, function (unitNo, unitErrors) {
            let messages = Array.isArray(unitErrors) ? unitErrors : [unitErrors];

            jQuery.each(messages, function (i, message) {
                if (!message) {
                    return;
                }

                lines.push('Unit ' + unitNo + ': ' + message);
            });
        });

        return lines.join("\n");
    }

    /**
     * Clear the data-file and asset-file selections after a clean import.
     *
     * @remarks
     * WEB-4314: nulling the ng-model alone leaves the native input's FileList
     * (and therefore the "file selected" label) in place, so the elements are
     * reset too. Called only on a fully successful import — a partially failed
     * import keeps the selection so the operator can retry.
     *
     * @returns {void}
     */
    _clearImportFileInputs() {
        const self = this;

        self.importParams.paymentInstrumentsAssetsFiles = null;
        self.importParams.paymentsExcelFile = null;

        jQuery('#payments-excel-file, #payment-instruments-assets-files').val('');
    }


}

PaymentsImportController.$inject = [
    '$timeout',
    '$window',
    'Upload',
    'SSHttpService',
    'SSConfigService',
    'SSAlertService',
    'SSUtilService',
    'OTPService',
    'SSAppService',
    'SSAwsService',
    'SSUserService',
    'SSConfirmationService'
];
app.controller('PaymentsImportController', PaymentsImportController);